import React from "react";

export const Footer = () => {
    return (
        <footer className='footer-section' id='footer'>
            <div className='section-content footer-main'>
                <div className='footer-brand'>
                    <h3 className='footer-brand-title'>A Plus Roadside Rescue</h3>
                    <p className='footer-brand-text'>
                        Mobile Mechanic & Roadside Assistance in Phoenix • Fast Response • Monday thru Sunday
                    </p>
                </div>

                <div className='footer-links'>
                    <h4 className='footer-links-title'>Quick Links</h4>
                    <ul>
                        <li><a href='#about'>About</a></li>
                        <li><a href='#services'>Services</a></li>
                        <li><a href='#contact'>Contact</a></li>
                    </ul>
                </div>
            </div>

            <div className='section-content footer-bottom'>
                <p className='copyright-text'>
                    © 2025-2026 A Plus Roadside Rescue LLC. All rights reserved.
                </p>
                <a className='byline-text' href='https://sweetestadsmedia.com/'>
                    Created by Sweetest Interactive AdsMedia
                </a>
            </div>
        </footer>
    )
}
